module.exports = __webpack_public_path__ + "media/application/images/icons/email-outline-318d93f9f6e3d49c5c7ae2387f47b44b.svg";